export default [
    'Education and Childcare',
    'Car Insurance',
    'Utilities - Power Bill',
    'Phone Services',
    'Utilities - Other',
    'Cable / Internet / Streaming',
  ]